import { createSlice } from '@reduxjs/toolkit';

import jwtService from 'app/services/jwtService';
import { setUserData } from 'app/auth/store/userSlice';

export const submitLogin =
  ({ username, password }) =>
  async (dispatch) => {
    dispatch(loginInitiated());

    return jwtService
      .signInWithEmailAndPassword(username, password)
      .then((user) => {
        dispatch(setUserData(user));
        dispatch(loginSuccess());
      })
      .catch((errors) => {
        dispatch(loginError(errors));
      });
  };

const initialState = {
  success: false,
  isLoading: false,
  error: '',
};

const loginSlice = createSlice({
  name: 'auth/login',
  initialState,
  reducers: {
    loginInitiated: (state) => {
      state.isLoading = true;
    },
    loginSuccess: (state, action) => {
      state.success = true;
      state.isLoading = false;
      state.error = '';
    },
    loginError: (state, action) => {
      state.success = false;
      state.isLoading = false;
      state.error = action.payload.message;
    },
  },
  extraReducers: {},
});

export const { loginSuccess, loginError, loginInitiated } = loginSlice.actions;

export default loginSlice.reducer;
